import { Component, HostListener, OnInit, ViewChild, ViewContainerRef } from '@angular/core'
import { FormType } from '../../enums/formType.enum';
import { CtrlBaseComponent } from '../ctrl-base.component';
import { breakpoints } from '../../environments/environment.breakpoints';

declare var $: any;

@Component({
  selector: 'ct-column',
  templateUrl: './ct-column.component.html',
  styleUrls: ['./ct-column.component.css'],
  host: {
    '[id]': 'getId()',
    '[hidden]': 'getHidden()',
    '[class]': "getClasses() + ' ' + getClass()"
  }
})
export class CtColumnComponent extends CtrlBaseComponent implements OnInit {

  @ViewChild('target', { read: ViewContainerRef }) target: ViewContainerRef;

  private size: string;
  private title: string;
  private type: FormType;
  private colCount: number;
  private currentCol: number;
  private showBorders: boolean = true;
  public isMediumSize: boolean = false;
  public isSmallSize: boolean = false;
  public isExtraSmall: boolean = false;
  private hasBottomDivider: boolean = false;

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.manageWindowResizing(window.innerWidth);
  }

  private manageWindowResizing(width: number) {
    this.isSmallSize = width < breakpoints.L && width >= breakpoints.M;
    this.isExtraSmall = width >= breakpoints.S && width < breakpoints.M;
    this.isMediumSize = width >= breakpoints.L;
  }

  constructor() {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
    this.onResize();
  }

  ngAfterViewInit() {
    this.paintChildren(this.getMetaData(), this.target);
    this.manageWindowResizing(window.innerWidth);
  }

  getClass() {
    const result = super.getEffectiveClass(this.isMediumSize, this.isSmallSize, this.isExtraSmall);
    return result;
  }


  getSize(): string { return this.size; }
  getTitle() { return this.title; }
  getClasses() { return `col-md-${this.getSize() ? this.getSize() : '12'}` + (this.getStyleClass() ? (' ' + this.getStyleClass()) : ""); }
  getType(): FormType { return this.type }
  getIsSummaryType() { return this.type === FormType.Summary }
  getColCount(): number { return this.colCount }
  getCurrentCol(): number { return this.currentCol }
  getShowBorders(): boolean { return this.showBorders }
  getHasBottomDivider(): boolean { return this.hasBottomDivider }


  setSize(size: string): void { this.size = size; }
  setTitle(title: string) { this.title = title; }
  setType(type: FormType): void { this.type = type }
  setColCount(colCount: number): void { this.colCount = colCount }
  setCurrentCol(currentCol: number): void { this.currentCol = currentCol }
  setShowBorders(showBorders: boolean): void { this.showBorders = showBorders }
  setHasBottomDivider(hasBottomDivider: boolean) { this.hasBottomDivider = hasBottomDivider }

}
